<template>
	<div class="mag-list-wrap">
		<div class="mag-header">
			<a href="/mag">
				<h2>Mag : a little thing of life</h2>
			</a>
			<div class="mag-nav">
				<ul>
					<li v-for="item in Categories" :key="item.Code">
						<a :href="'/mag/' + item.Code">
							{{ item.Name }}
						</a>
					</li>
				</ul>
			</div>
		</div>
		<div class="mag-list-content">
			<ul>
				<li v-for="item in list" :key="item.ID">
					<a :href="'/mag/article/' + item.ID">
						<div class="mag-cover" :style="{ backgroundImage: 'url(' + item.CoverImage + ')' }"></div>
						<div class="mag-list-info">
							<span class="post-time">{{ dateFormate(item.PostTime) }}</span>
							<span class="cate">{{ item.CategoryName }}</span>
							<h3>{{ item.Title }}</h3>
						</div>
					</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { dateFormate } from "@global/components/blog/ArticleTools";
import AlertDialog from "@global/helpers/alertDialog";

export default {
	name: "MagList",
	data() {
		return {
			Categories: [],
			list: [],
		};
	},
	created() {
		this.getCategory();
		this.getList();
	},
	methods: {
		dateFormate(PostTime) {
			return dateFormate(PostTime);
		},
		getCategory() {
			var self = this;

			$.ajax({
				type: "GET",
				url: API_URL.ARTICLE_CATEGORY,
				dataType: "json",
				xhrFields: {
					withCredentials: true,
				},
				error: function () {
					console.log("error");
				},
				success: function (res) {
					if (res.Code === 200) {
						self.Categories = res.Response.Categories;
					} else {
						AlertDialog.alert("系統忙線中,請稍後再試", function () {
							window.location.href = "/";
						});
					}
				},
			});
		},
		getList() {
			var self = this;

			$.ajax({
				type: "GET",
				url: API_URL.ARTICLE_LIST,
				data: { Category: location.href.split("/mag/")[1] },
				dataType: "json",
				xhrFields: {
					withCredentials: true,
				},
				error: function () {
					console.log("error");
				},
				success: function (res) {
					if (res.Code === 200) {
						self.list = res.Response.Data;
					} else {
						AlertDialog.alert("系統忙線中,請稍後再試", function () {
							window.location.href = "/";
						});
					}
				},
			});
		},
	},
};
</script>

<style></style>
